import React from 'react';
import styles from './Title.css';

type Props = {
    title: string;
    dataTestId: string;
};
function Title({ title, dataTestId }: Props) {
    return (
        <>
            <div className={styles.pageHeader} data-testid={dataTestId}>
                {title}
            </div>
        </>
    );
}

export default Title;
